import gql from 'graphql-tag';
import history from '../../history';
import { toastr } from 'react-redux-toastr';
import { setLoaderStart, setLoaderComplete } from '../loader/loader';


export function editUser(id, firstName, lastName, email, password, phoneDialCode, phoneNumber, userStatus, isBan, phoneCountryCode) {
  return async (dispatch, getState, { client }) => {

    const mutation = gql`
        
        mutation updateUser(
            $id: ID,
            $firstName: String,
            $lastName: String,
            $email: String,
            $password: String,
            $phoneDialCode: String
            $phoneNumber: String,
              $userStatus: String,
              $isBan: Int
              $phoneCountryCode: String
            ) {
              updateUser(
              id: $id
              firstName: $firstName
              lastName: $lastName
              email:$email
              password: $password
              phoneDialCode: $phoneDialCode
              phoneNumber: $phoneNumber
              userStatus: $userStatus
              isBan: $isBan
              phoneCountryCode: $phoneCountryCode
            )
            {
              status
              errorMessage
            }
          }
        `;

    dispatch(setLoaderStart('EditUser'));

    const { data } = await client.mutate({
      mutation,
      variables: {
        id,
        firstName,
        lastName,
        email,
        password,
        phoneDialCode,
        phoneNumber,
        userStatus,
        isBan,
        phoneCountryCode
      }
    });

    dispatch(setLoaderComplete('EditUser'));

    if (data && data.updateUser && data.updateUser.status === 200) {
      history.push('/siteadmin/users')
      toastr.success('Success', 'The user information has been updated successfully!')
    } else {
      errorMessage = (data && data.updateUser && data.updateUser.errorMessage) ? data.updateUser.errorMessage : errorMessage;
      toastr.error("Error!", errorMessage);
    }
  }
}